module.exports = __webpack_public_path__ + "img/yufei-logo-transparent.96d47c12.png";